<div class="settings-container">
    <div class="settings-card">
        <div class="user-header">
            <ng-container *ngIf="profileImg; else noImg">
                <img [src]="profileImg" alt="Profile Image" class="avatar" />
            </ng-container>

            <ng-template #noImg>
                <div class="avatar avatar-text">
                    {{ profileData?.first_name?.charAt(0)?.toUpperCase() }}
                </div>
            </ng-template>

            <div class="user-details">
                <h3>{{ profileData?.first_name }} {{ profileData?.last_name }}</h3>
                <p>{{ profileData?.email }}</p>
            </div>
        </div>


        <div class="settings-item" (click)="activeSection = 'profile'" routerLink="/profile">
            <span class="labl">Profile Information</span>
            <span class="arrow" routerLink="/profile"><i class="bi bi-caret-right-fill"></i></span>
        </div>

        <div class="settings-item" (click)="activeSection = 'country'" routerLink="/country">
            <span class="labl">Country Affiliation</span>
            <span class="arrow"  routerLink="/country"><i class="bi bi-caret-right-fill"></i></span>
        </div>

        <!-- <div class="settings-item" (click)="activeSection = 'subscription'" routerLink="/subscription">
            <span class="labl">Subscription Details</span>
            <span class="arrow" routerLink="/subscription"><i class="bi bi-caret-right-fill"></i></span>
        </div> -->

        <div class="settings-item logout" (click)="onLogout()">
            <span class="logot">Logout</span>
        </div>
    </div>

    <div class="settings-content">

        <app-profile-information *ngIf="activeSection === 'profile'" [profileData]="profileData" [profileImg]="profileImg"></app-profile-information>

        <app-country-affliation *ngIf="activeSection === 'country'"></app-country-affliation>
        <app-subscription *ngIf="activeSection === 'subscription'"></app-subscription>
    </div>
</div>